<template>
    <div id="Console">
        <el-card shadow = "never">
            <el-row>
                <el-col :span="20" :offset="1">
                    <el-form
                        :model="ruleForm" 
                        :rules="rules" 
                        ref="ruleForm"
                        label-width="80px"
                        class="demo-ruleForm"
                    >
                        <el-form-item
                            label="券号 :"
                            prop="voucherCode"
                        >
                             <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value1" :maxlength ="8" clearable></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label ="日期">
                            <el-date-picker
                                v-model="ruleForm.date"
                                type="daterange"
                                range-separator="至"
                                placeholder="选择日期"
                                value-format = "yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                >
                            </el-date-picker>
                            <p class="tip"><span>*</span>{{dateNullTip}}</p>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                            <el-button @click="downLoad2('操作流程')" type="success">下载表格</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-table
                        max-height="340"
                        border
                        style="width:100%"
                        :data ="tableData"  
                    >
                        <el-table-column
                            prop="VOUCHER_NO"
                            label="券号"
                            width="100"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="lastUpdateDate"
                            label="日期"
                            width="170"
                            :show-overflow-tooltip = "true"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="LAST_UPDATE_USER"
                            label="更新用户"
                            width="120"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="操作流程 : 生成 / 确认 / 分配 / 激活 / 销售 / 核销 / 调整"
                            header-align="center"
                        >   
                            <template slot-scope="scope">
                                <p>{{scope.row.TRANSACTION_TYPE}} <span v-if="scope.row.TRANSACTION_TYPE !== '确认' && scope.row.TRANSACTION_TYPE !== '生成'"> - 地点 : </span>
                                    <span v-if = 'scope.row.FROM_LOCATION !== "null"'><span v-if = 'scope.row.TO_LOCATION !== "null" && scope.row.FROM_LOCATION !== "null"'> 从 </span>  {{scope.row.FROM_LOCATION}}</span>
                                    <span v-if = 'scope.row.TO_LOCATION !== "null"'><span v-if = 'scope.row.TO_LOCATION !== "null" && scope.row.FROM_LOCATION !== "null"'> 到 </span>{{scope.row.TO_LOCATION}}</span>
                                    <span v-if = 'scope.row.TRANSACTION_TYPE == "销售"'> / 单号 : {{scope.row.ORDER_NO}} / 价格 : {{scope.row.UNIT_PRICE}}</span>
                                </p>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less" scoped>
@import '~@/assets/css/common';
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin,common],
    data(){
        var validatorQty = (rule,value,callback) => {
            if(value.value1 != ''){
                let value1 = this.trim(value.value1);
                if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value1) == false ){
                    callback(new Error("请填写大于0的数字"));
                }else if(/[+]/g.test(value.value1)){
                    callback(new Error("请输入大于0的数字"));
                }else if(value.value1.length != 8){
                    callback(new Error("请输入8位数的券号！"));
                }else{
                    callback();
                }
            }else{
                callback(new Error("至少输入一个券号！"));
            }
        }
        return {
            ruleForm:{
                voucherCode:{
                    value1:"",
                },
                date : ''
            },
            defaultVal :[],
            rules:{
                voucherCode: [
                    { validator : validatorQty,required: true,trigger:'blur',type:'number'},
                ]
            },
            tableData:[
                // {
                //     VOUCHER_NO : '',
                //     LAST_UPDATE_USER : '',
                //     LAST_UPDATE_USER : '',
                //     TRANSACTION_TYPE: '',
                //     FROM_LOCATION:'',
                //     TO_LOCATION : '',
                //     UNIT_PRICE : '',
                //     PAYMENT_TYPE : '',
                //     ORDER_NO : ''
                // }
            ]
        }
         
    },
    created (){
    },
    mounted(){
    },
    methods:{
        //下载表格
        downLoad2(name){
            this.isDownTable(this.tableData, this.downLoad ,name);
        },
        /**
         * @description 确认提交
         * @formName {Object} 请求的参数对象
         */
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let { date,voucherCode } = this.ruleForm ;
                     let userId = sessionStorage.getItem("userId") ;
                    this.tableData = [] ;
                    let params ;
                    if(date == null || date ==''){
                        params = {
                            act : 'movements',
                            code : voucherCode.value1,
                            userId
                        }
                    }else{
                        params = {
                            act : 'movements',
                            code : voucherCode.value1,
                            from : date[0],
                            to : date[1],
                            userId
                        }
                    }
                   this.getMovement(params) ;
                } else {
                    return false;
                }
            });
        },
        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },
        //显示表格
        getMovement(params){
            let that = this ;
             let userId = sessionStorage.getItem("userId") ;
            that.delType(params).then(res => {
                let {status,report} = res.data ;
                if(status == true){
                    let len = report.length;
                    if(len > 0){
                        let reportObj = report.map((elem) => {
                            return elem.TRANSACTION_TYPE = this.formalStatus(elem.TRANSACTION_TYPE)
                        });
                        let params1 = {
                            act : 'getPayments',
                            userId
                        }
                        let params2 = {
                            act : 'findLocations',
                            userId
                        }
                        let params3 = {
                            act : 'findUsers',
                            level : 'S',
                            userId
                        }
                        // this.getDes(params1,"code",report)
                        this.getDes(params2,"locationCode",report)
                        this.getDes(params3,"userId",report)
                        this.tableData = report ;
                    }else{
                        return ;
                    }
                }else{
                    this.promptMsg('加载失败',"info")
                }
            })
        },

        /**
         * @description 主要把报表的code转换成名称
         * @param {params} 请求参数
         * @code 返回的code，比如地点code
         * @arr {Array} 返回的报表
        */
        getDes(params,code,arr){
            let that =this;
            that.delType(params).then(res => {
                let {status ,list} = res.data ;
                if(status == true){
                    list.forEach(elem => {
                        if(elem.PAYMENT_TYPE == "null"){
                            elem.PAYMENT_TYPE = ''
                        }
                        arr.forEach(elem1 =>{
                                if(elem1.PAYMENT_TYPE == elem[code]){
                                    elem1.PAYMENT_TYPE = elem.description
                                }
                                if(elem1.PAYMENT_TYPE == 'null'){
                                    elem1.PAYMENT_TYPE = '' ;
                                }
                                if(elem1.FROM_LOCATION == elem[code]){
                                    elem1.FROM_LOCATION = elem.description;
                                    // elem1.TO_LOCATION = elem.description;
                                }
                                if(elem1.TO_LOCATION == elem[code]){
                                    elem1.TO_LOCATION = elem.description;
                                }
                                if(elem1.LAST_UPDATE_USER == elem[code]){
                                    elem1.LAST_UPDATE_USER = elem.name
                                }
                        })
                    })
                }else{
                    this.promptMsg('加载失败！','info')
                }
            })
        },
    }
}
</script>
